export default "__VITE_ASSET__6938c65d__"